import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/ebay-buyer-groups';

export default function Example() {
  return (
    <>
      <Head>
        <title>eBay Buyer Groups: Promote your coded coupons in bulk!</title>
        <meta
          name='description'
          content='Take advantage of the eBay Buyer Groups where you can control your target audience that receives your coded coupons. Learn all about this feature and how you can use it.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/ebay-buyer-groups' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/ebay-buyer-groups' />
        <meta property='og:title' content='eBay Buyer Groups: Promote your coded coupons in bulk!' />
        <meta
          property='og:description'
          content='Take advantage of the eBay Buyer Groups where you can control your target audience that receives your coded coupons. Learn all about this feature and how you can use it.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='April 14th, 2022' />
        <meta property='article:modified_time' content='April 14th, 2022' />
        <meta property='article:tag' content='eBay' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
